import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {CaseStudyPublicComponent} from '../../cms/case-study-public/case-study-public.component';
import {CaseStudyPluginComponent} from '../../cms/plugins/case-study-plugin/case-study-plugin.component';
import {PluginLoaderLayoutComponent} from '../../layouts/plugin-loader-layout/plugin-loader-layout.component';
import {DefaultLayoutComponent} from '../../layouts/default-layout/default-layout.component';
import {CaseStudyPublicRelatedProductsComponent} from '../../cms/case-study-public/case-study-public-related-products/case-study-public-related-products.component';
import {CaseStudyPublicRelatedProductsSliderComponent} from '../../cms/case-study-public/case-study-public-related-products-slider/case-study-public-related-products-slider.component';
import {CaseStudyPublicSliderComponent} from '../../cms/case-study-public/case-study-public-slider/case-study-public-slider.component';
import {TrustpilotReviewSliderModule} from '../../shared/trustpilot-review-slider/trustpilot-review-slider.component';
import {ContactCtaModule} from '../../shared/contact-cta/contact-cta.component';
import {ShareIconsComponent} from '../../cms/plugins/share-icons/share-icons.component';
import {DirectivesModule} from '../../directives/directives.module';

const routes: Routes = [
    {path: '', component: PluginLoaderLayoutComponent, pathMatch: 'full'},
    {
        path: '',
        component: DefaultLayoutComponent,
        children: [
            {path: ':slug', component: CaseStudyPublicComponent, pathMatch: 'full'},
            {path: 'page/:page', component: CaseStudyPluginComponent, pathMatch: 'full'},
        ]
    },
];

@NgModule({
    declarations: [
        CaseStudyPublicComponent,
        CaseStudyPublicRelatedProductsComponent,
        CaseStudyPublicRelatedProductsSliderComponent,
        CaseStudyPublicSliderComponent,
        ShareIconsComponent,
    ],
    imports: [
        CommonModule,
        [RouterModule.forChild(routes)],
        AngularSvgIconModule,
        TrustpilotReviewSliderModule,
        ContactCtaModule,
        DirectivesModule
    ],
    exports: [
        [RouterModule]
    ]
})
export class CaseStudyModule {
}
